import type { InfoField } from '@cheqroom/components';
import { Building } from '@cheqroom/icons';
import { useMemo } from 'react';

import { CustomField, SystemField, SystemFieldType } from '../../../hooks/item-fields/types';

/**
 * The preview fields for `fieldIds`: each field's sample value, else its name. They render as
 * `extraFields`, so `ItemInfo`/`KitInfo` pick each icon by id. `location` passes its own icon: in a
 * real row `ItemInfo.Location` draws it, which extra fields do not use.
 */
export const usePreviewFields = (
	fieldIds: string[],
	getFieldById: (fieldId: string) => SystemField<SystemFieldType> | CustomField | undefined,
	getDefaultValue: (fieldId: string) => string | undefined
): InfoField[] =>
	useMemo(
		() =>
			fieldIds.map((fieldId) => ({
				id: fieldId,
				value: getDefaultValue(fieldId) ?? getFieldById(fieldId)?.name ?? '',
				...(fieldId === SystemFieldType.location && { icon: Building }),
			})),
		[fieldIds, getFieldById, getDefaultValue]
	);
